<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  name: 'App',
  metaInfo: {
    title: 'Главная',
    titleTemplate: '%s',
  },
  data: () => ({
    app: null,
  }),
  mounted() {
    // it's time to hack this world
    this.app = document.querySelector('#app')
    window.addEventListener('resize', this.doResize)
    window.addEventListener('resize', this.resize)
    this.doResize()
    this.resize()
  },
  methods: {
    doResize() {
      this.app.style.height = `${window.innerHeight}px`
    },
    resize() {
      const ww = window.innerWidth

      let isDesktop = false
      let isTablet = false
      let isMobile = false

      if (ww > 950) {
        isDesktop = true
      } else if (ww > 650) {
        isTablet = true
      } else {
        isMobile = true
      }
      this.$store.commit('resetDimension')
      this.$store.commit('setCurrentDimension', { type: 'isDesktop', value: isDesktop })
      this.$store.commit('setCurrentDimension', { type: 'isTablet', value: isTablet })
      this.$store.commit('setCurrentDimension', { type: 'isMobile', value: isMobile })
    },
  },
  created() {
    if (process.env.NODE_ENV !== 'production') {
      window.$app = this
    }
  },
}
</script>
<style lang="scss">
@import './styles/main.scss';
</style>
